export default __webpack_public_path__ + "static/media/winter1.68e74699.png";